export const SAVE_REDIRECT_ROUTE = 'SAVE_REDIRECT_ROUTE';
export const REMOVE_REDIRECT_ROUTE = 'REMOVE_REDIRECT_ROUTE';
